import { JsonObject } from 'ta-json';
import { Link } from '@ess/jg-rule-executor';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_agreementLinks,
} from '@src/app/generated/GetAllRetailers';
import { LinkInput } from '@src/app/generated/globalTypes';

/**
 * Extension of link to convert from-and-to gql object
 */
@JsonObject()
export class PortalLink extends Link {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_agreementLinks): PortalLink {
    return new PortalLink(
      gql.href,
      gql.text
    );
  }

  toGqlInput(): LinkInput {
    return {
      href: this.href,
      text: this.text,
    };
  }
}
